<div>
    <canvas #chartCanvas [ngClass]="oneRecord == 1 ? 'canvas-container1' : 'canvas-container'"></canvas>
</div>